// La requete des personnes qu on peut inviter a une nouveaute ciblee (feat-feedback-les-nouveautes-
// se-publient). Hors de PublishAnnouncementModal.tsx : un fichier de composants n exporte que des
// composants (react-refresh/only-export-components) ; patron mentionsQuery.ts.
import { useQuery } from '@tanstack/react-query';
import { api } from '@gs/api-client';
import type { InvitableDto } from '../schemas';

/**
 * Les personnes proposees : celles qui ont un role sur l application dans la compagnie de l auteur,
 * servies par le serveur (aucune liste devinee au client), au plus 20 par recherche, jamais le
 * courriel. La requete ne vit que pendant une publication ciblee. Une erreur (route absente,
 * plafond atteint) laisse simplement la liste vide.
 */
export function useInvitables(saisie: string, enabled: boolean) {
  return useQuery({
    queryKey: ['feedback', 'invitables', saisie],
    queryFn: () =>
      api.get<InvitableDto[]>(`/api/feedback/invitables?q=${encodeURIComponent(saisie)}`),
    enabled,
    staleTime: 30_000,
    retry: false,
  });
}
